// extracted by mini-css-extract-plugin
module.exports = {"vertical_align_middle":"faq_vertical_align_middle__3jSO9","setting_modal_body":"faq_setting_modal_body__3Vsop"};